import { render, staticRenderFns } from "./DataTableExport.vue?vue&type=template&id=589d5d3e"
import script from "./DataTableExport.vue?vue&type=script&lang=js"
export * from "./DataTableExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports